import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1) + min);
}

function TextPlaceholder({ lines = 1, width = 'w-3/4', random = true }) {
  const structure = useMemo(() => {
    return Array.from({ length: lines }).map((_, lineIdx) => {
      const columnCount = random ? getRandomInt(1, 3) : 3;

      return {
        id: `line-${lineIdx}-${lines}`, // stable per render cycle
        columns: Array.from({ length: columnCount }).map((_, colIdx) => ({
          id: `col-${lineIdx}-${colIdx}-${lines}`
        }))
      };
    });
  }, [lines, random]);

  return (
    <div className="animate-pulse">
      {structure.map((line) => (
        <div key={line.id} className={`flex space-x-2 mb-4 ${width}`}>
          {line.columns.map((col) => (
            <div
              key={col.id}
              className="h-2 bg-gray-400 rounded flex-grow"
            />
          ))}
        </div>
      ))}
    </div>
  );
}

TextPlaceholder.propTypes = {
  lines: PropTypes.number,
  width: PropTypes.string,
  random: PropTypes.bool,
};

export default TextPlaceholder;